import React from "react"
import { ExternalLinkWrapper } from "../ExternalLinkWrapper"
import { BodyTextRegular } from "../typography/text"
import { css, useTheme } from "@emotion/react"
import { Link, useI18next } from "gatsby-plugin-react-i18next"

type Props = {
  href: string
  children: React.ReactNode
  internalLink?: boolean
  className?: string
}

export const FooterLink = ({
  href,
  children,
  internalLink = false,
  className,
}: Props) => {
  const theme = useTheme()
  const { language } = useI18next()
  const linkStyle = css`
    color: ${theme.colors.primary};
    cursor: pointer;
    text-decoration: none;
    &:hover {
      color: ${theme.colors.ctaMain};
    }
  `

  if (internalLink) {
    return (
      <Link css={linkStyle} to={href} language={language} className={className}>
        <BodyTextRegular>{children}</BodyTextRegular>
      </Link>
    )
  }

  return (
    <ExternalLinkWrapper css={linkStyle} href={href} className={className}>
      <BodyTextRegular>{children}</BodyTextRegular>
    </ExternalLinkWrapper>
  )
}
